import s from "./ProjectsActionsComponent.module.css";
import React, { useMemo } from "react";
import { Input, Radio, Select, Space } from "antd";
import { SortAscendingOutlined, SortDescendingOutlined } from "@ant-design/icons";

export const ProjectsActionsComponent = (props) => {
    const {
        searchQuery,
        setSearchQuery,
        sortBy,
        setSortBy,
        handleWorkSpaceChange,
        data, isSuccess, isLoading
    } = props;

    const handleChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleSortingChange = (e) => {
        setSortBy(e.target.value);
    };

    const selectOptions = useMemo(() => {
        if (isSuccess) {
            const items = data.workspaces.map((el) => {
                return {
                    label: el.name,
                    value: el.workspace_id,
                };
            });
            return [{ label: "All", value: "loading" }, ...items];
        }
    }, [isSuccess]);

    return (
        <div className={s.container}>
            <h1 className="projects-heading-title">Projects</h1>
            <Select
                defaultValue={props.currentWorkspace}
                showSearch
                onChange={(e) => handleWorkSpaceChange(e)}
                options={selectOptions}
                loading={isLoading}
                disabled={isLoading}
                filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            />
            <Input
                value={searchQuery}
                placeholder="Find projects"
                onChange={handleChange}
                allowClear
            />

            <div>
                <Space align="center">
                    Sort By:
                    <Radio.Group onChange={handleSortingChange} value={sortBy}>
                        <Radio value={"creation_date"}>Date Oldest</Radio>
                        <Radio value={"creation_date desc"}>Date Newest</Radio>
                        <Radio value={"name"}>
                            Name <SortAscendingOutlined />
                        </Radio>
                        <Radio value={"name desc"}>
                            Name <SortDescendingOutlined />
                        </Radio>
                    </Radio.Group>
                </Space>
            </div>
        </div>
    );
};
